import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import AppVo from '../blogData/AppVo';
import { MainStorage } from '../classes/MainStorage';
interface MyProps { appVo: AppVo | null, callback: Function }
interface MyState { appVo: AppVo | null }
class ModScreen extends Component<MyProps, MyState>
{
    private ms: MainStorage = MainStorage.getInstance();

    constructor(props: MyProps) {
        super(props);
        this.state = { appVo: this.props.appVo };
    }
    componentDidUpdate(prevProps: Readonly<MyProps>, prevState: Readonly<MyState>, snapshot?: any): void {
        if (prevProps.appVo !== this.props.appVo) {
            this.setState({ appVo: this.props.appVo });
        }
    }
    render() {
        //create an iframe that resizes to the size of the content
        //use the appVo.url to load the app
        //use the appVo.title as the title of the iframe
        //use a close button
        if (this.state.appVo === null) {
            return <div></div>;
        }
        let link: string = this.state.appVo.link;

        if ((this.ms.isUserLoggedIn===false || this.ms.isMembershipActive===false) && this.state.appVo.paid === 1) {
            link = this.state.appVo.freeLink;
        }
        return (<div><div className='shade' onClick={()=>{this.props.callback()}}></div><div className='mod-screen'>
            <Button variant='danger' className='close-button' onClick={() => { this.props.callback() }}>X</Button>
            <iframe className='frame-window' src={link} title={this.state.appVo.title} style={{ width: "100%", height: "100%", border: "none" }}></iframe>
        </div></div>)
    }
}
export default ModScreen;